module.exports = __webpack_public_path__ + "img/编组@2x.d8ae9e00.png";